import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../../services/customer.service';
import { Location } from '@angular/common';
import { AccountUserService } from 'src/app/services/account-user.service';
@Component({
  selector: 'app-view-label',
  templateUrl: './view-label.component.html',
  styleUrls: ['./view-label.component.css']
})
export class ViewLabelComponent implements OnInit {
  labelDetails: any;
  consumerId: number;
  constructor(private activatedRoute: ActivatedRoute, private location: Location,private accountuserService: AccountUserService, private router: Router) { }
  ngOnInit() {
console.log(this.activatedRoute.snapshot.params['id'])
   this.accountuserService.getDetails(this.activatedRoute.snapshot.params['id'])
   .subscribe(res => {
    this.labelDetails = res;

  });
  // this.customerService.getDataForm()
  // .subscribe(res => {
  //   alert('obj' + JSON.stringify(res));
  // });
  }
  // goBacktoList() {
  //   this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
  // }
  goBacktoListt() {
    this.location.back();
  }

}
